export const LcStorage = {
    getSelf : function(){
        let localStorage = window.localStorage;
        return localStorage;
    },
    getItem : function(key){
        let storage = LcStorage.getSelf();
        return storage ? storage.getItem(key) : null;
    },
    setItem : function(key, value){
        let storage = LcStorage.getSelf();
        try{
            storage.setItem(key, value || '');
        }
        catch(e){
            console.log(e);
        }
    },
    removeItem : function(key){
        let storage = LcStorage.getSelf();
        return storage ? storage.removeItem(key) : null;
    },
    clear : function(){
        let storage = LcStorage.getSelf();
        storage ? storage.clear() : null;
    }
}

export default {
    LcStorage
}


// WEBPACK FOOTER //
// ./client/util/storage.js